import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryAiLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 32 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M4 6.333c-.92 0-1.666.746-1.666 1.667v18.667c0 .92.746 1.666 1.667 1.666h22.666c.921 0 1.667-.745 1.667-1.666v-5h2v5a3.666 3.666 0 0 1-3.667 3.666H4.001a3.666 3.666 0 0 1-3.667-3.666V8a3.666 3.666 0 0 1 3.667-3.667h9v2H4Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M13.013 12.817 20.449 25H4.785l8.228-12.183ZM8.549 23h8.336l-3.957-6.484L8.549 23ZM6.667 11.667a.333.333 0 1 0 0 .666.333.333 0 0 0 0-.666ZM4.334 12a2.333 2.333 0 1 1 4.667 0 2.333 2.333 0 0 1-4.667 0Z"
            fill="#404145"/>
        <path d="M24 6.667A2.666 2.666 0 0 1 21.335 4a1.334 1.334 0 0 0-2.667 0 2.666 2.666 0 0 1-2.666 2.667 1.334 1.334 0 0 0 0 2.666A2.666 2.666 0 0 1 18.667 12a1.334 1.334 0 0 0 2.667 0 2.666 2.666 0 0 1 2.667-2.667 1.334 1.334 0 0 0 0-2.666ZM31 13.667a2 2 0 0 1-2-2 1 1 0 0 0-2 0 2 2 0 0 1-2 2 1 1 0 0 0 0 2 2 2 0 0 1 2 2 1 1 0 0 0 2 0 2 2 0 0 1 2-2 1 1 0 0 0 0-2Z"
            fill="#404145"/>
    </svg>
);
CategoryAiLargeIcon.displayName = 'CategoryAiLargeIcon';
export default CategoryAiLargeIcon;
